import React, { Suspense } from 'react';

import { getComponentFromName } from '../../lib/utils';

import ErrorBoundary from '../partials/ErrorBoundary';
import ErrorPage from './Error';
import Page from './Page';
import * as Pages from './index';

interface LoaderPageProps {
    page?: any | null;
    loading?: boolean;
    error?: any | null;
}

function LoaderPage({ page = null, loading = false, error = null }: LoaderPageProps) {
    if (error !== null) {
        return <ErrorPage statusCode={404} />;
    }
    const { type = null, url = null } = page || {};
    const TypedPage = getComponentFromName(type, Pages, Page) as React.ComponentType<{
        page: unknown;
    }> | null;
    return TypedPage !== null && !loading ? (
        // Keyed by URL so a chunk that failed to load (e.g. after a deploy) doesn't stick on the
        // next navigation
        <ErrorBoundary key={url} fallback={<ErrorPage statusCode={500} />}>
            <Suspense fallback={null}>
                <TypedPage page={page} />
            </Suspense>
        </ErrorBoundary>
    ) : null;
}

export default LoaderPage;
